import { run, ruleRunner } from 'validations/ruleRunner';
import { required, minimun, maximum } from 'validations/rules';

export const schema = [
  ruleRunner('weight', 'Peso', required),
  ruleRunner('height', 'Altura', required, minimun(1), maximum(100)),
  ruleRunner('width', 'Largura', required, minimun(1), maximum(100)),
  ruleRunner('length', 'Comprimento', required, minimun(1), maximum(100)),
];

export const validate = (delivery: any, validations: any) => {
  return run(delivery, validations);
};

export const isValid = (obj: { [key: string]: string }, key: string) => {
  return obj[key] ? true : false;
};
